import React from "react";
import * as AlertDialogComp from "@radix-ui/react-alert-dialog";
import { AlertDialog } from "./Base";
import "./styles.css";

type Props = {
  onCancel?: () => void;
  title?: string;
  message: string;
  children?: React.ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};
export const InfoAlertDialog: React.FC<Props> = ({
  open,
  onOpenChange,
  title,
  message,
  onCancel,
  children,
}) => (
  <AlertDialog trigger={children} open={open} onOpenChange={onOpenChange}>
    <AlertDialogComp.Overlay className="AlertDialogOverlay" />
    {title && (
      <AlertDialogComp.Title className="AlertDialogTitle">
        {title}
      </AlertDialogComp.Title>
    )}
    <AlertDialogComp.Description className="AlertDialogDescription">
      {message}
    </AlertDialogComp.Description>
    <div style={{ display: "flex", gap: 25, justifyContent: "flex-end" }}>
      <AlertDialogComp.Action asChild onClick={onCancel}>
        <button className="Button">Close</button>
      </AlertDialogComp.Action>
    </div>
  </AlertDialog>
);
